//
// Client-side storage - use this module instead of window.localStorage
//   - can store json safely, and it will be retrieved as json
//
// Fallback for localStorage is cookies
//
import features from './feature-detection'
import Cookie from './cookie'
import EventEmitter from 'events'

const events = new EventEmitter

const Storage = {
  on (event, handler) {
    events.on(event, handler)
  },

  setItem (key, value) {
    const errHandler = err => {
      if ((err.code || err.number || err.message) === 22) {
        throw new Error('HAPPENED A SECOND TIME')
      } else if (err.name === 'NS_ERROR_FILE_CORRUPTED') {
        throw new Error(`
          NS_ERROR_FILE_CORRUPTED thrown by FF. TODO - show message to user.
          http://stackoverflow.com/a/18878068/742624
        `)
      } else {
        throw new Error('some other error')
      }
    }

    try {
      if (features.localstorage) {
        window.localStorage.setItem(key, value)
      } else {
        Cookie.set(key, value)
      }
    } catch (e) {
      const code = e.code || e.number || e.message

      // remove our entire cache and try again
      // QuotaExceededError (also triggered in Private mobile Safari b/c is readonly) ||
      // FF NS_ERROR_DOM_QUOTA_REACHED
      if (code === 22 || code === 1014) {
        try {
          window.localStorage.setItem(key, value)
        } catch (err) {
          errHandler(err)
        }
      } else {
        throw e
      }
    }
  },

  getItem (key) {
    let value = Cookie.get(key)

    if (features.localstorage) {
      value = window.localStorage.getItem(key)
    }

    if (key && value) {
      try {
        return JSON.parse(value)
      } catch (err) {
        return value
      }
    }

    return null
  },

  removeItem (key) {
    if (features.localstorage) {
      window.localStorage.removeItem(key)
    } else {
      Cookie.remove(key)
    }

    return null
  },

  clear () {
    if (features.localstorage) {
      window.localStorage.clear()
    } else {
      // TODO - only remove those that were set through this API
      Cookie.removeAll()
    }

    return null
  },
}

// TODO - trigger this when using cookies as a fallback also
//      - need to figure out how to message other tabs when a cookie changes
// TODO - test this
window.addEventListener('storage', event => {
  let value = event.newValue

  try {
    value = JSON.parse(event.newValue)
  } catch (err) {
    // do nothing
  }
  events.emit('change', [event.key, value])
})

export default Storage
